import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU10');
    const configs = {
        title: t('title'),
        desc: t('desc'),
        tip: t('tip'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724297769492/EcoFlow%20X-Quiet.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1724297769492/EcoFlow%20X-Quiet.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725179691687/h5-dp5-mute.jpg',
    };

    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU10'} data-section-title={t('title')}>
            <EfSpec className="spec-x" />
            <EfSection {...configs} hasAnimation={false} />
        </div>
    );
}
